import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import {
  RentalImageEnhanceApplyDialogComponent,
  RentalImageEnhanceApplyDialogData,
} from './rental-image-enhance-apply-dialog.component'
import { Observable } from 'rxjs'

@Injectable()
export class RentalImageEnhanceApplyDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: RentalImageEnhanceApplyDialogData): Observable<void> {
    const defaultConfig: MatDialogConfig = {
      width: '800px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data,
    }

    return this.dialog.open(RentalImageEnhanceApplyDialogComponent, defaultConfig).afterClosed()
  }
}
